if (!customElements.get("lsg-press-hits")) customElements.define("lsg-press-hits", class LSGPressHits extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            carouselEl: ".js-carousel"
        };
        this.carouselEl = this.querySelector(this.selectors.carouselEl);
        this.init();
    }
    init() {
        this.carousel = new window.Flickity(this.carouselEl, {
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            accessibility: false,
            groupCells: true,
            autoPlay: true
        });
        document.addEventListener("DOMContentLoaded", ()=>{
            this.carousel.resize();
        });
    }
});